<template>
  <div class="sidebar">
    <sidebar-current-issue v-if="$route.name !== 'issueDetail'"></sidebar-current-issue>
    <sidebar-signup-button></sidebar-signup-button>
    <div class="pb-3"></div>
    <title-block title="Aims & Scope:" link-title="learn more" link-name="forAuthorsPolicies">
      <div class="sidebar-block-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget</div>
    </title-block>
    <title-block title="Impact Factor / Index / Archive:">
      <div class="sidebar-block-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</div>
    </title-block>
    <title-block title="Ethics & Malpractice Statement:" link-title="View Full Statement" link-name="forAuthorsPolicies">
      <div class="sidebar-block-content"><ethics-and-malpractice-content></ethics-and-malpractice-content></div>
    </title-block>
    <sidebar-quick-links></sidebar-quick-links>
    <sidebar-sponsorship></sidebar-sponsorship>
    <!--ToDO: add link -->
    <title-block :title="`${site.name} Enhanced View:`" link-title="learn more" link-name="forAuthorsPolicies">
      <img :src="getStaticPath('img/temp/' + site.mobileSiteCoverUrl)" />
    </title-block>
  </div>

</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import EthicsAndMalpracticeContent from '@/components/about/EthicsAndMalpracticeComponent'
  import SidebarSignupButton from '@/components/main-layout/sidebar/SidebarSignUpButtonComponent'
  import SidebarCurrentIssue from '@/components/main-layout/sidebar/SidebarCurrentIssueComponent'
  import SidebarQuickLinks from '@/components/main-layout/sidebar/SidebarQuickLinksComponent'
  import SidebarSponsorship from '@/components/main-layout/sidebar/SidebarSponsorshipComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'

  export default {
    components: {
      EthicsAndMalpracticeContent,
      TitleBlock,
      SidebarSignupButton,
      SidebarCurrentIssue,
      SidebarQuickLinks,
      SidebarSponsorship
    },
    name: 'sidebar',
    mixins: [ UtilityMixin ],
    data () {
      return {
        site: {
          name: process.env.SITE_NAME,
          mobileSiteCoverUrl: 'MobileSiteCover.png'
        }
      }
    }
  }
</script>


<style scoped lang="scss">
  .sidebar-block-content {
    background-color: $light-grey-color;
    padding: 15px;
    font-family: 'Open Sans';
    font-size: 14px;
    color: $accent-color-3;
    line-height: 17px;
    img {
      width: 100%;
    }
  }
  .sidebar {
    section {
      img {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarComponent.vue?7a12adcd